import React from 'react';
export var SplitContext = React.createContext({ mode: 'vertical' });
//# sourceMappingURL=split-context.js.map